export const AVATARS = [
  { id: "av_1", name: "Alex",    seed: "WhosonAlex2025",    bg: "from-violet-500 to-purple-700"   },
  { id: "av_2", name: "Jordan",  seed: "WhosonJordan2025",  bg: "from-cyan-500 to-blue-700"      },
  { id: "av_3", name: "Riley",   seed: "WhosonRiley2025",   bg: "from-rose-400 to-pink-700"      },
  { id: "av_4", name: "Morgan",  seed: "WhosonMorgan2025",  bg: "from-amber-400 to-orange-600"   },
  { id: "av_5", name: "Casey",   seed: "WhosonCasey2025",   bg: "from-emerald-400 to-teal-700"   },
  { id: "av_6", name: "Sam",     seed: "WhosonSam2025",     bg: "from-fuchsia-500 to-purple-700" },
  { id: "av_7", name: "Drew",    seed: "WhosonDrew2025",    bg: "from-indigo-400 to-cyan-600"    },
  { id: "av_8", name: "Quinn",   seed: "WhosonQuinn2025",   bg: "from-pink-400 to-rose-700"      },
];

export const getAvatar = (avatarId) =>
  AVATARS.find((a) => a.id === avatarId) || AVATARS[0];

export const getAvatarUrl = (seed) =>
  `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(seed)}&backgroundColor=transparent`;
